import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JpbWidgetMainTextContainerDefaultBox} from "./jpb-widget-main-text-container.default.box";


export const JpbWidgetMainTextContainerBox = styledByTheme(JpbWidgetMainTextContainerDefaultBox)
    // .forMrGreen(JpbWidgetMainTextContainerDefaultBox)
    // .forCasino777(JpbWidgetMainTextContainerDefaultBox)
    .apply();